import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import dotenv from 'dotenv';

dotenv.config();

ReactDOM.render(
  <GoogleOAuthProvider clientId="470934482733-ifgjmq4jhh7smrk9erfos8crirq9juh8.apps.googleusercontent.com"> <React.StrictMode>
    <Provider store={store}>
      <App /> 
    </Provider>
  </React.StrictMode></GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
